import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Gen3Features } from '../components/Gen3Features';
import { FeaturedProducts } from '../components/FeaturedProducts';
import { ShopByCategory } from '../components/ShopByCategory';
import { TeamBuyersSection } from '../components/TeamBuyersSection';
import { SupportSection } from '../components/SupportSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 flex flex-col" data-id="element-484">
      <Header data-id="element-485" />

      <main className="flex-grow" data-id="element-486">
        <Hero data-id="element-487" />
        <Gen3Features data-id="element-488" />
        <ShopByCategory data-id="element-489" />
        <FeaturedProducts data-id="element-490" />
        <TeamBuyersSection data-id="element-491" />
        <SupportSection data-id="element-492" />
      </main>

      <Footer data-id="element-493" />
    </div>;
}